import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    type: String,
    message: String
  }

  connect() {
    if (!this.messageValue) return

    const typeMap = {
      notice: "success",
      alert: "error",
      error: "error",
      success: "success"
    }

    const toastrType = typeMap[this.typeValue] || "info"

    if (window.toastr && typeof toastr[toastrType] === "function") {
      toastr[toastrType](this.messageValue)
    }

    // Espelha o flash no sininho (momentâneo, client-side).
    window.dispatchEvent(new CustomEvent("flash:new", {
      detail: { type: toastrType, message: this.messageValue }
    }))
  }
}